import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// states
import ShowsState from './context/shows/ShowsState';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ShowsState>
      <App />
    </ShowsState>
  </React.StrictMode>
);
reportWebVitals();
